import { flatten } from 'ramda';
import { useEffect } from 'react';
import { Engine } from 'json-rules-engine';

const useRulesEngine = (form) => {
  const formWatchGuarantees = form.watch('guarantees');

  const engine = new Engine();
  const rules = flatten(
    Object.values(formWatchGuarantees)
      .filter((g) => g.ruleset)
      .map((g) => g.ruleset)
  ).map((rule) => JSON.parse(rule));
  rules.forEach((rule) => {
    engine.addRule(rule);
  });

  const json = JSON.stringify(formWatchGuarantees);

  useEffect(() => {
    const guarantees = JSON.parse(json);
    engine.run(guarantees).then(({ results }) => {
      results.forEach((result) => {
        result.event.params.codes.forEach((code) => {
          Object.entries(result.event.params.properties).forEach(([key, value]) => {
            // If key and value in properties are not empty => trigger the rule
            if (key) {
              form.setValue(`guarantees.${code}.${key}`, value);
            }
          });
        });
      });
    });
  }, [json]);
};

export default useRulesEngine;
